import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-teal-50 flex flex-col">
      {/* Nav */}
      <nav className="px-8 py-5 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-3xl text-emerald-600">♥</span>
          <span className="text-xl font-bold text-gray-900">VitalQuant</span>
        </div>
        <button
          onClick={() => navigate('/login')}
          className="px-5 py-2 bg-emerald-600 text-white rounded-lg text-sm font-semibold hover:bg-emerald-700 transition-colors"
        >
          Sign In
        </button>
      </nav>

      {/* Hero */}
      <main className="flex-1 flex flex-col items-center justify-center text-center px-6 pb-24">
        <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 text-xs font-semibold px-3 py-1.5 rounded-full mb-6">
          <span>●</span> AI-powered personal health
        </div>
        <h1 className="text-5xl font-extrabold text-gray-900 leading-tight max-w-2xl mb-6">
          Your health data,{' '}
          <span className="text-emerald-600">your AI doctor</span>
        </h1>
        <p className="text-gray-500 text-lg max-w-xl mb-10">
          Connect Apple Watch data with your personal health history. Get AI-driven insights, daily summaries, and chat with specialist personas — all privately.
        </p>
        <div className="flex gap-4">
          <button
            onClick={() => navigate('/login?mode=signup')}
            className="px-8 py-3.5 bg-emerald-600 text-white rounded-xl font-semibold hover:bg-emerald-700 transition-colors shadow-lg"
          >
            Get Started Free
          </button>
          <button
            onClick={() => navigate('/login')}
            className="px-8 py-3.5 border border-gray-300 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 transition-colors"
          >
            Sign In
          </button>
        </div>

        {/* Feature pills */}
        <div className="mt-16 flex flex-wrap justify-center gap-3">
          {[
            '♥ Heart Rate & HRV',
            '⚖ Weight Tracking',
            '😴 Sleep Analysis',
            '💊 Medication Log',
            '👨‍👩‍👧 Family History',
            '⚕ AI Specialist Chat',
          ].map((f) => (
            <span key={f} className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-700 shadow-sm">
              {f}
            </span>
          ))}
        </div>
      </main>
    </div>
  );
}
